import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class FlashProvider extends HttpRequest {
  createFlashShipment (payload) {
    this.setHeader(getAuthToken())
    return this.post('/flash/create-orders', payload)
  }

  recreateFlashShipment (payload) {
    this.setHeader(getAuthToken())
    return this.post('/flash/recreate-order', payload)
  }

  getRequestLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/flash-express-logs', query)
  }

  getWebhookLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/flash/webhook', query)
  }
}

export default FlashProvider
